import { getJson, postJson, putJson } from './client'
import type { NewOpportunity, OpportunityEdit, OpportunityFocus } from '../types/workbench'

// Opportunities as stored engagements (REQ-121, REQ-122): chosen or created BEFORE a draft is crafted. A derived
// opening stays a proposal until the rep makes it one here. The stage is not edited here; it goes through the
// correction control the lead page already has. Nothing here sends.
const root = (spoke: string) => `/api/spokes/${encodeURIComponent(spoke)}/scout/opportunities`

export const opportunitiesApi = {
  /** Makes an opportunity by hand (201); a refusal carries why (an empty subject, an account not yours). */
  create: (spoke: string, body: NewOpportunity) => postJson<OpportunityFocus>(root(spoke), body),
  /** The opportunity whole: /focus, because the bare /opportunities/{id} is an older account-shaped read. */
  get: (spoke: string, engagementId: string) => getJson<OpportunityFocus>(`${root(spoke)}/${encodeURIComponent(engagementId)}/focus`),
  /** Changes what the rep set up; the subject only on a by-hand opportunity no thread has joined (the API refuses otherwise). */
  edit: (spoke: string, engagementId: string, body: OpportunityEdit) => putJson<OpportunityFocus>(`${root(spoke)}/${encodeURIComponent(engagementId)}`, body),
}
